import type { ExternalSystemDto } from '../external-systems/models';
import type { PagedRequestDto } from '../pagination/models';

export interface ServiceDto {
  id: number;
  name: string;
  code: number;
  serviceTypeId: number;
  serviceTypeName?: string;
  description?: string;
  vendorId: number;
  vendorName: string;
  externalSystems: ExternalSystemDto[];
}

export interface ServiceForExternalSystemDto {
  id: number;
  name: string;
  description?: string;
  code: number;
  vendorCode?: string;
}

export interface ServiceForExternalSystemPagedRequestDto extends PagedRequestDto {
  externalSystemCode: string;
  serviceNameFilter: string;
}

export interface ServiceInputDto {
  id: number;
  name: string;
  code: number;
  serviceTypeId: number;
  description?: string;
  vendorId: number;
  externalSystemIds: number[];
}

export interface ServicePagedRequestDto extends PagedRequestDto {
  name?: string;
  code?: number;
  serviceTypeId?: number;
  vendorId?: number;
  externalSystemIds: number[];
}
